import has from 'lodash/has';
import createBaseForm from './createBaseForm';
import { mixin as createFormMixin } from './createForm';
import { getParams } from './utils';

function getDOMNode(instance: any) {
    // If instance is already a DOM element, return it directly
    if (instance && instance.nodeType === 1) {
        return instance;
    }

    // If instance has a DOM node property (common in some component libraries)
    if (instance && instance.input && instance.input.nodeType === 1) {
        return instance.input;
    }

    // If instance has a focus method, it might be a form control
    if (instance && typeof instance.focus === 'function') {
    // Try to get the underlying DOM element
        if (instance.input) {
            return instance.input;
        }
        // For some components, the instance itself might be the DOM element
        return instance;
    }

    // Fallback: return null if we can't determine the DOM node
    return null;
}

const mixin = {
    getForm() {
        return {
            ...createFormMixin.getForm.call(this),
            validateFieldsAndScroll: this.validateFieldsAndScroll,
        };
    },
    validateFieldsAndScroll(ns: any, opt: any, cb: any) {
        const { names, callback, options } = getParams(ns, opt, cb);
        const newCb = (error: any, values: any) => {
            if (error) {
                const validNames = this.fieldsStore.getValidFieldsName();
                let firstTop: number;
                validNames.forEach((name: string) => {
                    if (has(error, name)) {
                        const instance = this.getFieldInstance(name);
                        if (instance) {
                            const node = getDOMNode(instance);
                            if (node && node.getBoundingClientRect) {
                                const top = node.getBoundingClientRect().top;
                                if (node.type !== 'hidden' && (firstTop === undefined || firstTop > top)) {
                                    firstTop = top;
                                }
                            }
                        }
                    }
                });
            }
            if (typeof callback === 'function') {
                callback(error, values);
            }
        };
        return this.validateFields(names, options, newCb);
    },
};

export default function createDOMForm(option?: any) {
    return createBaseForm(
        {
            ...option,
        },
        [mixin]
    );
}
